import { ethers } from "ethers";

export function blockchainAddressEquals(address1: string, address2: string): boolean {
    if (!address1 || !address2) {
        return false;
    }

    if (ethers.utils.isAddress(address1) && ethers.utils.isAddress(address2)) {
        return ethers.utils.getAddress(address1) === ethers.utils.getAddress(address2);
    } else if (!ethers.utils.isAddress(address1) && !ethers.utils.isAddress(address2)) {
        if (address1 === address2) {
            return true;
        }

        const coercedAddress1 = +address1.toLowerCase().trim();
        const coercedAddress2 = +address2.toLowerCase().trim();
        if (isNaN(+coercedAddress1) || isNaN(+coercedAddress2)) {
            return false;
        }

        return coercedAddress1 === coercedAddress2;
    }

    throw new Error(`addresses are not consistently EVM or not: ${address1} | ${address2}`);
}
